import { WebPage } from 'commons/types/DTO/bank'

export interface WebPageReturnValue {
  webPage: WebPage | undefined
  isWebPageRequestPending: boolean
}
